/**
 * Money as Stripe reports it: minor units (öre) plus a currency code.
 *
 * Fraction digits are dropped because every price in the catalogue is a whole krona, and
 * "149 kr" reads as a price where "149,00 kr" reads as an accounting entry. A price that
 * ever needs öre should change this rather than work around it.
 */
export const formatAmount = (minorUnits: number, currency: string, locale: string) =>
  new Intl.NumberFormat(locale, {
    currency: currency.toUpperCase(),
    maximumFractionDigits: 0,
    style: 'currency',
  }).format(minorUnits / 100)
